import { createContext } from 'react';
//This context is being flipped between true/false and passed to the `UISideNavItem` as the 'key' prop
// as a way to re-render it to update the active item.
// Link to issue create for UIComponents: https://git.hubteam.com/HubSpot/UIComponents/issues/12758
const SideNavReRenderContext = /*#__PURE__*/createContext({
  sideNavReRender: false,
  updateSideNavReRender: () => {}
});
export default SideNavReRenderContext;